import * as moment from 'moment';
import { Deserializable } from '../protocols/deserializable';
import { MonthlyPensionAnnuityType } from '../shared/monthly-pension-annuity-type';
import { MonthlyPensionAnnuityTypeIdEnum } from '../enum/shared/monthly-pension-annuity-type-id.enum';
import { AnnuityGuaranteePeriodType } from '../shared/annuity-guarantee-period-type';
import { AnnuityGuaranteeTypeIdEnum } from '../enum/shared/annuity-guarantee-type-id.enum';
import { BaseType } from '../base/base-type';
import { MonthlyPensionAccountPaymentInstructions } from './monthly-pension-account-payment-instructions';
import { MonthlyPensionSourceJurisdiction } from './monthly-pension-source-jurisdiction';
import { MonthlyPensionAccountNote } from './monthly-pension-account-note';
import { MemberAccountStatusIdEnum } from './enum/member-account-status-id.enum';
import { LifeStatusIdEnum } from '../enum/shared/life-status-id.enum';
import { RelationshipStatus } from '../enum/shared/relationship-status';
import { MonthlyPensionAccountStateTypeEnum } from './enum/monthly-pension-account-state-type.enum';

export class MonthlyPensionAccountDetails implements Deserializable {
  public id!: number;
  public accountId!: number;
  public isAccountOwner!: boolean;
  public accountOwnerName!: string | null;
  public annuityTypeId!: MonthlyPensionAnnuityTypeIdEnum;
  public annuityType!: MonthlyPensionAnnuityType;
  public annuityGuaranteePeriodId!: AnnuityGuaranteeTypeIdEnum;
  public annuityGuaranteePeriod!: AnnuityGuaranteePeriodType;
  public stateId!: MonthlyPensionAccountStateTypeEnum;
  public state!: BaseType;
  public isSplit!: boolean;
  public effectiveDate!: string;
  public accountStartDate!: string | null;
  public nextPaymentDate!: string | null;
  public guaranteeEndDate!: string | null;
  public jointPensionerId!: number | null;
  public jointPensionerName!: string | null;
  public purchasePrice!: number | null;
  public conversionRate!: number | null;
  public monthlyBenefit!: number | null;
  public ownerCurrentMonthlyAmount!: number | null;
  public survivorPercentage!: number | null;
  public survivorBenefit!: number | null;
  public pensionCost!: number | null;
  public paidToDate!: number | null;
  public paymentInstructions!: MonthlyPensionAccountPaymentInstructions[];
  public sourceJurisdictions!: MonthlyPensionSourceJurisdiction[];
  // Internal Portal only
  public accountOwnerMemberId?: number;
  public ownerLifeStatusId?: LifeStatusIdEnum | null;
  public ownerDeathDate?: string | null;
  public ownerRelationshipStatusTypeId?: RelationshipStatus | null;
  public accountStatusId?: MemberAccountStatusIdEnum;
  public canEngageJointLifeSurvivorship?: boolean;
  public notes?: MonthlyPensionAccountNote[];

  public isEffectiveDateInFuture(): boolean {
    return moment(this.effectiveDate).isAfter(moment(), 'day');
  }

  public hasGuaranteePeriod(): boolean {
    return this.annuityGuaranteePeriodId !== AnnuityGuaranteeTypeIdEnum.ZeroYear;
  }

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (this.annuityType) {
      this.annuityType = Deserialize.instanceOf(MonthlyPensionAnnuityType, this.annuityType);
    }

    if (this.annuityGuaranteePeriod) {
      this.annuityGuaranteePeriod = Deserialize.instanceOf(AnnuityGuaranteePeriodType, this.annuityGuaranteePeriod);
    }

    if (this.paymentInstructions?.length) {
      this.paymentInstructions = Deserialize.arrayOf(
        MonthlyPensionAccountPaymentInstructions,
        this.paymentInstructions
      );
    }

    if (this.sourceJurisdictions?.length) {
      this.sourceJurisdictions = Deserialize.arrayOf(MonthlyPensionSourceJurisdiction, this.sourceJurisdictions);
    }

    if (this.notes) {
      this.notes = Deserialize.arrayOf(MonthlyPensionAccountNote, this.notes);
    }
  }
}
